import { ScreenLoading } from '@/components/loading';
import { ScreenError } from '@/components/screen-error';
import { ScreenAuditWithDrawer } from '@/components/screens/audit-criteria-screen';
import { useApplications } from '@/hooks/use-applications';
import { useScreenProps } from '@/store/theme';

export function AuditCriteriaPage() {
  const sp = useScreenProps();
  const {
    data: apps,
    isLoading,
    isError,
    error,
    refetch,
    isFetching,
    dataUpdatedAt,
  } = useApplications();

  // Erro ANTES do loading: sem isso a tela fica em spinner infinito quando a
  // query falha (isLoading volta a false, mas `apps` segue undefined).
  if (isError && !apps) {
    return (
      <ScreenError
        error={error}
        onRetry={() => void refetch()}
        retrying={isFetching}
        active="audit"
        role="admin"
        title="Auditoria 2026"
        subtitle="Critérios de conformidade por aplicação"
      />
    );
  }
  if (isLoading || !apps) return <ScreenLoading dark={sp.dark} />;

  return (
    <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
      <ScreenAuditWithDrawer
        {...sp}
        apps={apps}
        onRefresh={() => void refetch()}
        refreshing={isFetching}
        dataUpdatedAt={dataUpdatedAt}
      />
    </div>
  );
}
